"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _input = _interopRequireDefault(require("@paprika/input"));

var _popover = _interopRequireDefault(require("@paprika/popover"));

var _button = _interopRequireDefault(require("@paprika/button"));

var _toast = _interopRequireDefault(require("@paprika/toast"));

var _useI18n = _interopRequireDefault(require("@paprika/l10n/lib/useI18n"));

var _helpers = require("@paprika/helpers");

var _Clipboard = _interopRequireDefault(require("@paprika/icon/lib/Clipboard"));

var _Input = _interopRequireDefault(require("./components/Input/Input"));

var _Button = _interopRequireDefault(require("./components/Button/Button"));

var _Popover = _interopRequireDefault(require("./components/Popover/Popover"));

var sc = _interopRequireWildcard(require("./CopyInput.styles"));

var _excluded = ["children", "isReadOnly", "hasInputContainer", "hasValueContainer", "value"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function CopyInput(props) {
  var children = props.children,
      isReadOnly = props.isReadOnly,
      hasInputContainer = props.hasInputContainer,
      hasValueContainer = props.hasValueContainer,
      value = props.value,
      moreProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var extendedInputProps = (0, _helpers.extractChildrenProps)(children, _Input["default"]);
  var extendedButtonProps = (0, _helpers.extractChildrenProps)(children, _Button["default"]);
  var extendedPopoverProps = (0, _helpers.extractChildrenProps)(children, _Popover["default"]);
  var I18n = (0, _useI18n["default"])();

  var inputRef = /*#__PURE__*/_react["default"].createRef();

  var buttonRef = /*#__PURE__*/_react["default"].createRef();

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      isClickedTooltipOpen = _React$useState2[0],
      setIsClickedTooltipOpen = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(false),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      isHoverTooltipOpen = _React$useState4[0],
      setIsHoverTooltipOpen = _React$useState4[1];

  var prevIsClickedTooltipOpen = _react["default"].useRef(isClickedTooltipOpen);

  _react["default"].useEffect(function () {
    var timeout;

    if (!prevIsClickedTooltipOpen.current && isClickedTooltipOpen) {
      timeout = setTimeout(function () {
        return setIsClickedTooltipOpen(false);
      }, 5000);
    }

    prevIsClickedTooltipOpen.current = isClickedTooltipOpen;
    return function () {
      return clearTimeout(timeout);
    };
  }, [isClickedTooltipOpen]);

  function handleButtonClick() {
    var textToCopy = inputRef.current.value;

    if (navigator.clipboard) {
      navigator.clipboard.writeText(textToCopy);
    } else {
      // Fall back browser support
      var textbox = document.createElement("textarea");
      var activator = document.activeElement;
      document.body.appendChild(textbox);
      textbox.value = textToCopy;
      textbox.select();
      activator.focus();
      document.execCommand("copy");
      document.body.removeChild(textbox);
    }

    setIsClickedTooltipOpen(true);
    setIsHoverTooltipOpen(false);
  }

  return /*#__PURE__*/_react["default"].createElement(sc.CopyInput, (0, _extends2["default"])({
    "data-pka-anchor": "copy-input",
    hasDefaultButtonBorder: !hasInputContainer
  }, moreProps), hasValueContainer ? /*#__PURE__*/_react["default"].createElement(sc.Value, null, value) : null, !hasInputContainer ? /*#__PURE__*/_react["default"].createElement(sc.HiddenInput, {
    ref: inputRef,
    defaultValue: value
  }) : /*#__PURE__*/_react["default"].createElement(_input["default"], (0, _extends2["default"])({
    isReadOnly: isReadOnly,
    ref: inputRef,
    defaultValue: value
  }, extendedInputProps)), /*#__PURE__*/_react["default"].createElement("div", {
    ref: buttonRef,
    "data-pka-anchor": "copy-input.button"
  }, /*#__PURE__*/_react["default"].createElement(_button["default"].Icon, (0, _extends2["default"])({
    a11yText: I18n.t("copyInput.hover_tooltip"),
    kind: "primary"
  }, extendedButtonProps, {
    onClick: handleButtonClick,
    onMouseOver: function onMouseOver() {
      return setIsHoverTooltipOpen(true);
    },
    onMouseOut: function onMouseOut() {
      return setIsHoverTooltipOpen(false);
    },
    onFocus: function onFocus() {
      return setIsHoverTooltipOpen(true);
    },
    onBlur: function onBlur() {
      return setIsHoverTooltipOpen(false);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Clipboard["default"], null))), /*#__PURE__*/_react["default"].createElement(_popover["default"], (0, _extends2["default"])({
    align: "bottom",
    getPositioningElement: function getPositioningElement() {
      return buttonRef.current;
    },
    isDark: true,
    isEager: true,
    isOpen: isHoverTooltipOpen && !isClickedTooltipOpen
  }, extendedPopoverProps), /*#__PURE__*/_react["default"].createElement(_popover["default"].Content, null, /*#__PURE__*/_react["default"].createElement(_popover["default"].Card, null, I18n.t("copyInput.hover_tooltip"))), /*#__PURE__*/_react["default"].createElement(_popover["default"].Tip, null)), /*#__PURE__*/_react["default"].createElement(_popover["default"], (0, _extends2["default"])({
    align: "bottom",
    getPositioningElement: function getPositioningElement() {
      return buttonRef.current;
    },
    isOpen: isClickedTooltipOpen,
    shouldKeepFocus: true
  }, extendedPopoverProps), /*#__PURE__*/_react["default"].createElement(_popover["default"].Content, null, /*#__PURE__*/_react["default"].createElement(_popover["default"].Card, null, I18n.t("copyInput.clicked_tooltip"))), /*#__PURE__*/_react["default"].createElement(_popover["default"].Tip, null)), isClickedTooltipOpen && /*#__PURE__*/_react["default"].createElement(_toast["default"], {
    kind: _toast["default"].types.kind.VISUALLY_HIDDEN,
    "aria-hidden": true,
    isPolite: true
  }, I18n.t("copyInput.clicked_tooltip")));
}

var propTypes = {
  /** Used for CopyInput.Input */
  children: _propTypes["default"].node,

  /** Is the input read-only. */
  isReadOnly: _propTypes["default"].bool,

  /** If the value will be rendered in an Input component or hidden */
  hasInputContainer: _propTypes["default"].bool,

  /** If a plain text version of the value will be rendered */
  hasValueContainer: _propTypes["default"].bool,

  /** Default value for the input */
  value: _propTypes["default"].string
};
var defaultProps = {
  children: null,
  isReadOnly: true,
  hasInputContainer: true,
  hasValueContainer: false,
  value: ""
};
CopyInput.displayName = "CopyInput";
CopyInput.propTypes = propTypes;
CopyInput.defaultProps = defaultProps;
CopyInput.Input = _Input["default"];
CopyInput.Button = _Button["default"];
CopyInput.Popover = _Popover["default"];
var _default = CopyInput;
exports["default"] = _default;
//# sourceMappingURL=CopyInput.js.map